export default "__VITE_ASSET__b8f5d3bb__"